import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

export default class extends Controller {
  static values = {
    updateUrl: String,
    autoShow: Boolean,
  }
  static targets = [
    'errorMessage',
    'modal',
    'profileStatusText',
    'oppositeProfileStatusText',
    'iconWrapper',
    'profileStatusTextWrapper',
    'descriptionHtml'
  ]

  connect() {
    const modalElement = this.hasModalTarget ? this.modalTarget : this.element;
    this.modal = new Modal(modalElement)
    if (this.hasAutoShowValue) {
      this.#showModal()
    }
  }

  updateProfileStatus(event) {
    const button = event.currentTarget;
    const profileStatus = button.dataset.profileStatus;

    fetch(this.updateUrlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ profile_status: profileStatus })
    })
      .then(response => response.json())
      .then(data => {
        this.#updateProfileStatusText(data, button)

        this.modal.hide()
      })
      .catch(error => {
        console.error(error)
        this.#showErrorMessage()
      })
  }

  #updateProfileStatusText(data, button) {
    if (this.hasProfileStatusTextTarget) {

      this.profileStatusTextTargets.forEach(target => {
        target.textContent = data.profile_status_text
      })
    }

    if (this.hasOppositeProfileStatusTextTarget) {
      this.oppositeProfileStatusTextTarget.textContent = data.opposite_profile_status_text
    }

    button.dataset.profileStatus = data.opposite_profile_status
    this.iconWrapperTargets.forEach(target => {
      target.classList.toggle('bg-gray-100');
      target.classList.toggle('bg-success-300');
    });
    this.profileStatusTextWrapperTargets.forEach(target => {
      target.classList.toggle('text-gray-500');
      target.classList.toggle('text-success-800');
    });

    if (this.hasDescriptionHtmlTarget) {  
      this.descriptionHtmlTarget.innerHTML = data.description_html
    }
  }

  #showModal() {
    this.modal.show()
  }

  #showErrorMessage() {
    this.errorMessageTarget.classList.remove('d-none');
  }
}
